import {
  useMultiStyleConfig,
  forwardRef,
  chakra,
  omitThemingProps,
} from '@chakra-ui/react-v2';
import type { AlertProps as ChakraAlertProps } from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';
import { OverrideProperties } from 'type-fest';

import { AlertStatus } from './types';
import { AlertProvider, AlertStylesProvider } from './utils/AlertContext';

export type AlertProps = OverrideProperties<
  ChakraAlertProps,
  {
    status: AlertStatus;
  }
>;

export const Alert = forwardRef<AlertProps, 'div'>(function Alert(props, ref) {
  const { status = 'info', addRole = true, ...rest } = omitThemingProps(props);

  const styles = useMultiStyleConfig('Alert', { ...props });

  return (
    <AlertProvider value={{ status }}>
      <AlertStylesProvider value={styles}>
        <chakra.div
          data-status={status}
          role={addRole ? 'alert' : undefined}
          ref={ref}
          {...rest}
          className={cx('chakra-alert', props.className)}
          __css={styles.container}
        />
      </AlertStylesProvider>
    </AlertProvider>
  );
});

Alert.displayName = 'Alert';
